<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费方式：</span>
        </div>
        <el-select v-model="formData.payType" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in payTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">金额：</span>
        </div>
        <el-input v-model="formData.payAmount" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox" style="vertical-align: top;">
          <span class="line-text">备注：</span>
        </div>
        <el-input type="textarea" :rows="3" v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/ParkingService'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import {pattern} from '../../../utils/regular'

  export default {
    components: {
      ButtonConfirmNext,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'custom-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧停车',
          name: 'amount-allocation'
        }, {
          value: '金额配置'
        }],
        mainTitle: '修改金额配置',
        subheading: '修改客户停车缴费金额配置信息',
        currentCode: '',
        payTypeList: [{
          value: '1',
          label: '月缴'
        }, {
          value: '2',
          label: '季缴'
        }, {
          value: '3',
          label: '半年缴'
        }, {
          value: '4',
          label: '年缴'
        }],
        vacancyRoomList: [],
        intendRoomArr: [],
        formData: {
          payType: '1',       // 缴费方式
          payAmount: '',     // 金额
          memo: '',          // 备注
        }
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getParkingBasicConfigByCode()
    },
    methods: {
      toCustomManagement () {
        this.$router.push({
          name: 'amount-allocation'
        })
      },
      getParkingBasicConfigByCode () {
        this.$axios.get(`${api.getParkingBasicConfigByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode == 1) {
              this.formData = res.data.data
            }
          })
          .catch(errorHandler('获取停车费用信息失败'))
      },
      confirm () {
        let payAmountReg = pattern.subsidy
        let payAmountTest = payAmountReg.test(this.formData.payAmount)
        if (!payAmountTest) {
          nError('请输入准确金额且保留两位小数')
          return false
        }
        this.$axios.post(api.updateParkingBasicConfig, this.formData)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('修改成功')
              this.toCustomManagement()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toCustomManagement()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: -webkit-baseline-middle;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px 0;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/AmountAllocation/AmountModify.vue